export default {
  setNews(state, news) {
    state.news = news;
  },
  addNews(state, news) {
    state.news = [...state.news, ...news];
  },
  setCount(state, count) {
    state.count = count;
  }
};
